<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<card-component class="has-table has-mobile-sort-spaced" :hasButtonSlot="true" title="一覧" icon="format-list-bulleted">
			<b-button slot="button" type="is-info" :loading="isExportLoading" @click="onExportButtonClick">CSV出力</b-button>

			<b-table
				:loading="isLoading"
				:paginated="true"
				:per-page="$consts.TABLE_PER_PAGE"
				:striped="true"
				:hoverable="true"
				:data="list"
				@page-change="onPageChange"
				>

				<template slot-scope="props">
					<b-table-column label="日時" field="created" sortable>
						{{ props.row.created }}
					</b-table-column>
					<b-table-column label="投稿者" field="staff_name" sortable>
						{{ props.row.staff_name }}
					</b-table-column>
					<b-table-column label="カテゴリー" field="category_name" sortable>
						{{ props.row.category_name }}
					</b-table-column>
					<b-table-column label="タイトル" field="title" sortable>
						{{ props.row.title }}
					</b-table-column>
					<b-table-column label="いいね！" field="like_count" sortable number>
						{{ props.row.like_count }}
					</b-table-column>
					<b-table-column label="コメント" field="comment_count" sortable number>
						{{ props.row.comment_count }}
					</b-table-column>
					<b-table-column label=" ">
						<div class="buttons is-right">
							<button class="button is-small is-danger" type="button" @click="onDeleteClick(props.row.id)">削除</button>
						</div>
					</b-table-column>
				</template>

				<section class="section" slot="empty">
					<table-empty :loading="isLoading"></table-empty>
				</section>

				<section class="page-info" slot="bottom-left">
					<page-info :current="currentPage" :data="list"></page-info>
				</section>
			</b-table>
		</card-component>
	</div>

</template>

<style lang="scss" scoped>

</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import TableEmpty from '@/components/TableEmpty'
import PageInfo from '@/components/PageInfo'
import SearchBar from '@/components/SearchBar'
import DatePicker from '@/components/DatePicker'

export default {
	name: 'News',
	components: {
		TitleBar,
		CardComponent,
		TableEmpty,
		PageInfo,
		SearchBar,
		DatePicker,
	},
	data() {
		return {
			isLoading: false,
			list: [],
			currentPage: 1,
			isExportLoading: false,
		}
	},
	computed: {
		titleStack () {
			return [
				'投稿一覧'
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		onExportButtonClick: async function() {
			this.isExportLoading = true;

			let ep = 'news/export';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.downloadCSV(res.data);
			} catch (error) {
				this.$utils.log(error);
				alert(error.response.data.message);
			} finally {
				this.isExportLoading = false;
			}
		},
		downloadCSV: function(data) {
			let fileName = `export_news.csv`;
			this.$utils.downloadCSV(data, fileName, true);
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			this.isLoading = true;
			let ep = 'news';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.list = res.data.list;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onDeleteClick: async function(id) {
			if (!window.confirm(this.$consts.MSG_CONFIRM_DELETE)) {
				return false;
			}

			this.isLoading = true;
			let ep = 'news/' + id;
			this.$utils.log(ep);

			try {
				let res = await this.$api.delete(ep, null, true);
				this.$utils.log(res);
				this.list.some(function(v, i){
					if (v.id === id) this.list.splice(i, 1);
				}, this);
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onPageChange: function(val) {
			this.currentPage = val;
		},
	},
}
</script>
